"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAPPER = exports.QUEUE = exports.SUB_FLOW = exports.SCRIPT = exports.DATE_RANGE_ROUTER = exports.DAY_OF_WEEK_ROUTER = exports.TEAM = exports.VOICEMAIL = exports.PLAY = exports.SAY = exports.PLUGIN = exports.ZONE_ROUTER = exports.NUMBER_PLAN = exports.DNIS_ROUTER = exports.ANI_ROUTER = exports.TIME_ROUTER = exports.TIME_RANGE_ROUTER = exports.HUNT_GROUP = exports.OUTBOUND_OVERRIDE = exports.MATCH_START = exports.ROUTE_START = exports.REMOTE = exports.CLIENT = exports.SIP_GATEWAY = exports.SIP = exports.ASSET = exports.INBOUND_NUMBER = exports.WEBHOOK = exports.IP_AUTHENTICATION = void 0;
const VOICEMAIL = 'VOICEMAIL';
exports.VOICEMAIL = VOICEMAIL;
const TEAM = 'TEAMS';
exports.TEAM = TEAM;
const SAY = 'SAY';
exports.SAY = SAY;
const PLAY = 'PLAY';
exports.PLAY = PLAY;
const SIP = 'SIP';
exports.SIP = SIP;
const SIP_GATEWAY = 'SIP_GATEWAY';
exports.SIP_GATEWAY = SIP_GATEWAY;
const CLIENT = 'CLIENT';
exports.CLIENT = CLIENT;
const REMOTE = 'REMOTE';
exports.REMOTE = REMOTE;
const ROUTE_START = 'ROUTE_START';
exports.ROUTE_START = ROUTE_START;
const MATCH_START = 'MATCH_START';
exports.MATCH_START = MATCH_START;
const HUNT_GROUP = 'HUNT_GROUP';
exports.HUNT_GROUP = HUNT_GROUP;
const ANI_ROUTER = 'ANI_ROUTER';
exports.ANI_ROUTER = ANI_ROUTER;
const DNIS_ROUTER = 'DNIS_ROUTER';
exports.DNIS_ROUTER = DNIS_ROUTER;
const NUMBER_PLAN = 'NUMBER_PLAN';
exports.NUMBER_PLAN = NUMBER_PLAN;
const ZONE_ROUTER = 'ZONE_ROUTER';
exports.ZONE_ROUTER = ZONE_ROUTER;
const TIME_RANGE_ROUTER = 'TIME_RANGE_ROUTER';
exports.TIME_RANGE_ROUTER = TIME_RANGE_ROUTER;
const DAY_OF_WEEK_ROUTER = 'DAY_OF_WEEK_ROUTER';
exports.DAY_OF_WEEK_ROUTER = DAY_OF_WEEK_ROUTER;
const DATE_RANGE_ROUTER = 'DATE_RANGE_ROUTER';
exports.DATE_RANGE_ROUTER = DATE_RANGE_ROUTER;
const SCRIPT = 'SCRIPT';
exports.SCRIPT = SCRIPT;
const PLUGIN = 'PLUGIN';
exports.PLUGIN = PLUGIN;
const SUB_FLOW = 'SUB_FLOW';
exports.SUB_FLOW = SUB_FLOW;
const QUEUE = 'QUEUE';
exports.QUEUE = QUEUE;
const MAPPER = 'MAPPER';
exports.MAPPER = MAPPER;
//Resources
const IP_AUTHENTICATION = 'IP_AUTHENTICATION';
exports.IP_AUTHENTICATION = IP_AUTHENTICATION;
const WEBHOOK = 'WEBHOOK';
exports.WEBHOOK = WEBHOOK;
const INBOUND_NUMBER = 'INBOUND_NUMBER';
exports.INBOUND_NUMBER = INBOUND_NUMBER;
const ASSET = 'ASSET';
exports.ASSET = ASSET;
// Depreciated
const TIME_ROUTER = 'TIME_ROUTER';
exports.TIME_ROUTER = TIME_ROUTER;
const OUTBOUND_OVERRIDE = 'OUTBOUND_OVERRIDE';
exports.OUTBOUND_OVERRIDE = OUTBOUND_OVERRIDE;
